import $ from 'jquery';

global.$ = global.jQuery = $;
import svg4everybody from 'svg4everybody';
import slick from 'slick-carousel';
require('@fancyapps/fancybox');
require('sticky-kit/dist/sticky-kit.js');

import scroll from './components/scroll';
import custom from './components/custom';
import sliders from './components/sliders';
import popup from './components/popup';
import Tabs from './components/tabs';

document.addEventListener("DOMContentLoaded", () => {
  if ($(window).width() > 1200) {
    $(".js-sticky").stick_in_parent({
      offset_top: 95
    });
  }
  $.fancybox.defaults.hash = false;
  svg4everybody();
  sliders();
  scroll();
  popup();
  new Tabs();
  custom();
});

$(window).on('load resize', function () {
  $('.preloader').addClass('hide');
})

$(window).on('load resize', function () {
  if ($(window).width() < 1200) {
    $('.header__mobile-box').append($('.header__nav'));
    $('.header__mobile-box').append($('.header__contacts'));
    $('.header__mobile-box').append($('.header__call-master'));
    $('.product-card__mobile-holder').append($('.product-card__sliders'));
    $('.product-card__mobile-holder').append($('.product-card__options .product-card__btns'));
    $('.product-card__mobile-holder').append($('.product-card__options .product-card__controls'));
  } else {
    $('.header__left').append($('.header__nav'));
    $('.header__call-master').insertBefore($('.header__controls'));
    $('.header__contacts').insertBefore($('.header__call-master'));
    $('.product-card__sliders').insertBefore($('.product-card__options'));
    $('.product-card__options').append($('.product-card__mobile-holder .product-card__btns'));
    $('.product-card__options').append($('.product-card__mobile-holder .product-card__controls'));
  }
})


// WEBPACK FOOTER //
// app/scripts/index.js